module.exports = __webpack_public_path__ + "c_static/img/default_icon_Fund-record_default@2x.bdef51d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img/default_icon_Fund-record_default@2x.png
// module id = 3PLy
// module chunks = 33